import { render, staticRenderFns } from "./WordsAdminView.vue?vue&type=template&id=92bb93e6&scoped=true"
import script from "./WordsAdminView.vue?vue&type=script&lang=js"
export * from "./WordsAdminView.vue?vue&type=script&lang=js"
import style0 from "./WordsAdminView.vue?vue&type=style&index=0&id=92bb93e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bb93e6",
  null
  
)

export default component.exports